import {EyeIcon, EyeOffIcon} from '@heroicons/react/outline';
import {useState} from 'react';
import {Link} from 'react-router-dom';

import {Button} from '@/components';
import {Input} from '@/components/common/Input';
import {appPaths} from '@/config/appPaths';

import type {LoginFormProps} from './useLogin';

const LoginForm = ({isLoading, handleLogin, handleChange}: LoginFormProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => setShowPassword((prev) => !prev);

  return (
    <div className="min-h-screen w-full dark:bg-dark-background flex justify-center items-center px-4">
      <div className="w-full sm:w-4/5 md:w-3/5 lg:w-2/5 flex flex-col justify-center items-center border rounded-md py-7 px-4 dark:border-dark-navBorder">
        <h1
          className="text-center text-gray-700 dark:text-gray-100 font-semibold text-xl"
          data-cy="admin-login-heading"
        >
          Afriex Admin Portal
        </h1>

        <div className="flex flex-col justify-center items-center w-full my-5 p-2 sm:p-5">
          <form
            className="w-full sm:w-3/5 flex flex-col space-y-10"
            onSubmit={handleLogin}
            data-cy="admin-login-form"
          >
            <Input
              onChange={handleChange}
              label="Email"
              type="email"
              name="email"
              required
              className="w-full dark:text-gray-200"
              data-cy="admin-login-email"
            />

            <div className="relative w-full">
              <Input
                onChange={handleChange}
                label="Password"
                type={showPassword ? 'text' : 'password'}
                name="password"
                required
                className="w-full pr-10 dark:text-gray-200"
                data-cy="admin-login-password"
              />

              <Button
                type="button"
                onClick={togglePassword}
                variant="unStyled"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                className="absolute right-3 top-11 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
              >
                {showPassword ? (
                  <EyeOffIcon className="h-5 w-5" />
                ) : (
                  <EyeIcon className="h-5 w-5" />
                )}
              </Button>
            </div>

            <Button
              variant="solid"
              colorScheme="cyan"
              type="submit"
              isLoading={isLoading}
              loadingText="Logging in..."
              data-cy="admin-login-submit"
            >
              Login
            </Button>

            <Link
              to={`/${appPaths.forgotPassword}`}
              className="text-sm text-center text-cyan-600 hover:underline dark:text-cyan-400"
              data-cy="admin-login-forgot-password"
            >
              Forgot password?
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
